import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertBody,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase";

interface Props {
  visitId: string;
}

const ScheduleVisitButton: React.FC<Props> = ({ visitId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScheduling, setIsScheduling] = useState(false);

  const handleSubmit = async () => {
    setIsScheduling(true);
    try {
      const fn = httpsCallable(functions, "scheduleVisit");
      await fn({ visitId });
      setIsOpen(false);
    } catch (error: any) {
      console.error("Error scheduling visit:", error);
      window.alert(error.message || "Failed to schedule visit. Please try again later.");
    }
    setIsScheduling(false);
  };

  return (
    <>
      <Button type="button" color="green" onClick={() => setIsOpen(true)}>
        Schedule Visit
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Mark as Scheduled</AlertTitle>
        <AlertBody>
          <AlertDescription>
            Are you sure you want to mark this visit as scheduled?
          </AlertDescription>
        </AlertBody>
        <AlertActions>
          <Button plain onClick={() => setIsOpen(false)} disabled={isScheduling}>
            Cancel
          </Button>
          <Button color="green" onClick={handleSubmit} disabled={isScheduling}>
            Yes
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default ScheduleVisitButton;
